export enum SmsOptInStatus {
  unsent = 'unsent',
  pending = 'pending',
  rejected = 'rejected',
  subscribed = 'subscribed',
  opted_out = 'opted_out',
  stopped = 'stopped',
  removed = 'removed',
}
